import { faCodeBranch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IconProps } from '.';

export const CodeBranchIcon = ({ className = '' }: IconProps) => {
  return <FontAwesomeIcon icon={faCodeBranch} className={className} />;
};
